import React from "react";

export default function TheSmartDadPlan() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 py-10">
      <div className="max-w-4xl w-full bg-white shadow-md rounded-lg overflow-hidden">
        <img
          src="https://414photos.s3.us-east-1.amazonaws.com/1017(2)Artboard+1.png"
          alt="The Smart Dad Plan"
          className="w-full h-auto object-contain"
        />
      </div>
    </div>
  );
}
